import { BrowserRouter } from 'react-router-dom';
import { FullProvider } from './providers';
import Routes from './routes';

export default function App() {
  return (
    <BrowserRouter>
      <FullProvider>
        <Routes />
      </FullProvider>
    </BrowserRouter>
  );
}
